import { render } from "./ConfigurationAlerts.vue?vue&type=template&id=38661b45&scoped=true"
import script from "./ConfigurationAlerts.vue?vue&type=script&lang=js"
export * from "./ConfigurationAlerts.vue?vue&type=script&lang=js"

import "./ConfigurationAlerts.vue?vue&type=style&index=0&id=38661b45&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38661b45"]])

export default __exports__